import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { QueueStatusEnum } from 'PointOfSale/modules/common/constants';
import TimeDelayComponent from 'PointOfSale/modules/layouts/component/servingOptions/TimeDelayComponent';
import IconWithPrimarySecondaryLabel from 'PointOfSale/modules/layouts/component/servingOptions/IconWithPrimarySecondaryLabel';

const AutoServeDropDownItems = props => {
  const {
    sessions,
    activeSession,
    onAutoServeClick,
    increment,
    decrement,
  } = props;
  const IconWidth = '30%';
  const textWidth = '70%';
  return (
    <React.Fragment>
      <Dropdown.Item
        key="dropDownItemStart"
        value={QueueStatusEnum.ON}
        className="menuNotSelected borderNone borderBottomWithGray"
        onClick={onAutoServeClick}
      >
        <IconWithPrimarySecondaryLabel
          key="autoServeOn"
          IconWidth={IconWidth}
          icon={'video play'}
          textWidth={textWidth}
          secondaryLabel={'Start'}
          primaryClassName={'text-primary'}
          IconClassName={'sessionDropDownItem iconCss'}
          labelClassName={'sessionDropDownItem'}
        />
      </Dropdown.Item>
      <Dropdown.Item
        key="dropDownItemOff"
        value={QueueStatusEnum.OFF}
        className="menuNotSelected borderNone borderBottomWithGray"
        onClick={onAutoServeClick}
      >
        <IconWithPrimarySecondaryLabel
          key="autoServeOff"
          IconWidth={IconWidth}
          icon={'stop circle'}
          textWidth={textWidth}
          secondaryLabel={'Off'}
          primaryClassName={'text-primary'}
          IconClassName={'sessionDropDownItem iconCss'}
          labelClassName={'sessionDropDownItem'}
        />
      </Dropdown.Item>
      <Dropdown.Item
        key="dropDownItemDelay"
        className="menuNotSelected borderNone"
        value="delay"
        onClick={onAutoServeClick}
      >
        <TimeDelayComponent
          seconds={sessions[activeSession].timeInterval}
          increment={increment}
          decrement={decrement}
        />
      </Dropdown.Item>
    </React.Fragment>
  );
};

AutoServeDropDownItems.propTypes = {
  sessions: PropTypes.object,
  activeSession: PropTypes.string,
  queueStatus: PropTypes.string,
  onAutoServeClick: PropTypes.func,
  increment: PropTypes.func,
  decrement: PropTypes.func,
};

export default AutoServeDropDownItems;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/component/servingOptions/AutoServeDropDownItems.js